import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import ProgressHeader from "../Component/ProgressHeader";
import Name from "../assets/firstName.png";
import { IoMdArrowDropdown } from "react-icons/io";
import { useFormData } from "../Context/FormContext";

export const MedicalInformation = ({ errors: externalErrors, setErrors: externalSetErrors }) => {
  const { formData, setFormData } = useFormData();
  const [localErrors, setLocalErrors] = useState({});
//   const formRef = useRef(null);
//   const navigate = useNavigate();
  const errors = externalErrors ?? localErrors;
  const setErrors = externalSetErrors ?? setLocalErrors;

  const bloodGroups = ["A+", "A−", "B+", "B−", "AB+", "AB−", "O+", "O−"];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      if (name === "medicalCondition" && value === "No") {
        return {
          ...prev,
          medicalInformation: {
            ...prev.medicalInformation,
            [name]: value,
            medicalConditionDetails: "",
          },
        };
      }

      return {
        ...prev,
        medicalInformation: {
          ...prev.medicalInformation,
          [name]: value,
        },
      };
    });

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

//   const validateForm = () => {
//     const errors = {};
//     const {
//       medicalCondition = "",
//       medicalConditionDetails = "",
//       bloodGroup = "",
//     } = formData?.medicalInformation || {};

//     if (!String(medicalCondition).trim()) {
//       errors.medicalCondition = "Medical condition is required";
//     }

//     if (medicalCondition === "Yes" && !String(medicalConditionDetails).trim()) {
//       errors.medicalConditionDetails = "Please provide details for your condition";
//     }

//     if (!String(bloodGroup).trim()) {
//       errors.bloodGroup = "Please select your blood group";
//     }

//     setErrors(errors);
//     return errors;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) return;
//     navigate("/registration/membership");
//   };

	return (
		<div className="contents">
			{/* <ProgressHeader
				title="MEDICAL"
				nextTitle="INFORMATION"
				currentStep={3}
				totalSteps={4}
			/> */}

			{/* <div className="bg-[#0C0C0C] px-4 py-6 md:px-12 xl:px-24 md:py-20  font-lufga"> */}
				{/* <form
					ref={formRef}
					onSubmit={handleSubmit}
					className="w-full max-w-8xl text-white grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-14 lg:gap-24"
				> */}
					<div className="flex flex-col gap-6">
						<div>
							<p className="text-[14px] md:text-[20px]  mb-3">
								Do you have any medical conditions or allergies?
							</p>
							<div className="flex gap-4">
								{["Yes", "No"].map((option) => (
									<label
										key={option}
										className="flex items-center gap-2 text-[#B0B0B0] text-base cursor-pointer"
									>
										<input
											type="radio"
											name="medicalCondition"
											value={option}
											checked={formData.medicalInformation.medicalCondition === option}
											onChange={handleChange}
											className="hidden"
										/>
										<div
											className={`w-6 h-6 rounded-full flex items-center justify-center
        								${formData.medicalInformation.medicalCondition === option ? "bg-[#D3631D]" : "bg-[#2c2c2c]"
												}`}
										>
											<div className="w-2.5 h-2.5 bg-white rounded-full" />
										</div>
										<span>{option}</span>
									</label>
								))}
							</div>
							{errors.medicalCondition && (
								<p className="text-red-500 text-sm mt-2">
									{errors.medicalCondition}
								</p>
							)}
						</div>

						{formData.medicalInformation.medicalCondition === "Yes" && (
							<div>
								<p className="text-base md:text-xl  mb-2">
									If yes, please provide details
								</p>
								<div className="relative">
									<textarea
										name="medicalConditionDetails"
										placeholder="Enter Details here..."
										value={formData.medicalInformation.medicalConditionDetails}
										onChange={handleChange}
										className="w-full xl:w-[80%] h-52 p-4 pl-12 rounded-xl font-lufga border-none bg-[#282828] text-white placeholder-[#949494] focus:outline-none  resize-none text-[16px] lg:text-[18px]"
									/>
									<img
										src={Name}
										alt="icon"
										className="absolute left-4 top-4 w-6 h-6 pointer-events-none"
									/>
								</div>
								{errors.medicalConditionDetails && (
									<p className="text-red-500 text-sm mt-2">{errors.medicalConditionDetails}</p>
								)}
							</div>
						)}
					</div>

					<div className="flex flex-col w-full gap-2">
						<label className="text-[#FFFFFF] text-[16px] lg:text-[20px] font-lufga mt-4 md:mt-0">
							Blood Group
						</label>
						<div className="relative flex items-center bg-[#282828] rounded-full px-6 py-4">

							<select
								name="bloodGroup"
								value={formData.medicalInformation.bloodGroup}
								onChange={handleChange}
								className="no-autofill-bg bg-[#282828] text-[#949494] placeholder-[#949494] border-none font-lufga text-[14px] md:text-[18px] appearance-none outline-none w-full rounded-full px-6 py-0"
							>
								<option value="" disabled hidden>
									Enter Blood Group...
								</option>
  {bloodGroups.map((bloodGroup) => (
									<option key={bloodGroup} value={bloodGroup}>
										{bloodGroup}
									</option>
								))}
							</select>
							<div className="pointer-events-none absolute right-8 top-4 transform -translate-y-1/2 text-white text-sm">
								<IoMdArrowDropdown className="w-6 h-6 " />
							</div>
						</div>
						{errors.bloodGroup && (
							<p className="text-red-500 text-sm mt-1">{errors.bloodGroup}</p>
						)}
					</div>

					{/* <div className="col-span-1 md:col-span-2 flex justify-center gap-6 mt-8">
						<button
							type="button"
							onClick={() => navigate("/registration/emergencycontact")}
							className="border border-solid border-[#D3631D] bg-transparent cursor-pointer text-white px-10 py-2 rounded-full text-[24px] md:text-[30px] font-league transition w-full sm:w-auto"
						>
							BACK
						</button>
						<button
							type="button"
							onClick={() => formRef.current.requestSubmit()}
							className="bg-[#D3631D] cursor-pointer text-white px-10 py-2 rounded-full text-[24px] md:text-[30px] font-league border-none w-full sm:w-auto"
						>
							NEXT
						</button>
					</div>
				</form>
			</div> */}
		</div>
	);
};
